<template>
  <!-- <div class="flex flex-col md:flex-row gap-4 md:gap-10 rounded-xl md:justify-evenly bg-[var(--c-primary)] p-8">
    <ButtonWhite class="flex justify-center items-center w-full md:w-auto" @click="a">{{ $t('admin.actions.missingDoc')
      }}</ButtonWhite>
    <ButtonWhite class="flex justify-center items-center w-full md:w-auto" @click="a">{{ $t('admin.actions.passSent') }}
    </ButtonWhite>
    <ButtonWhite class="flex justify-center items-center w-full md:w-auto" @click="a">{{
      $t('admin.actions.contractSigned') }}</ButtonWhite>
  </div> -->

  <div class="flex flex-col md:flex-row py-6 justify-between gap-4">
    <div class="flex flex-wrap md:flex-nowrap w-full md:w-auto justify-between gap-4">
      <!-- Excel «Clientes registrados», para superadmin y Back Office, acotado por fecha de alta (ADS-0083),
           obligatoria y de un año como máximo (ADS-0186) -->
      <div v-if="canExportClients" class="w-full md:w-auto">
        <ExportFetch export-endpoint="/user/user/export" :file-name="$t('admin.export.fileName')" date-range
          :from-label="$t('admin.export.dateFrom')" :to-label="$t('admin.export.dateTo')" />
      </div>

      <PrintTableComponent :title="$t('admin.titles.print')" :fields="fields" :items="items"
        @print-started="() => console.log($t('admin.table.print.started'))"
        @print-completed="() => console.log($t('admin.table.print.completed'))"
        @print-failed="(error) => console.error($t('admin.table.print.failed'), error)" />

      <RouterLink to="new-admin">
        <ButtonWhite class="md:hidden flex items-center gap-2 text-[#385660]">
          {{ $t('admin.buttons.addNew') }}
          <PlusIcon />
        </ButtonWhite>
      </RouterLink>

    </div>

    <div class="flex md:gap-4">
      <RouterLink to="new-admin">
        <ButtonWhite class="hidden md:flex items-center gap-2 text-[#385660]">
          {{ $t('admin.buttons.addNew') }}
          <PlusIcon />
        </ButtonWhite>
      </RouterLink>


    </div>
  </div>

  <TitlePrimary :title="$t('admin.table.titles.main')" class="w-full" />

  <div class="md:hidden">
    <CardTable v-if="role == 'superadmin'" :fields="fields" :items="items.length > 0 ? [items[currentItemIndex]] : []"
      :showOptions="true" route="/admin-detail" :listOptions="optionsList" />
    <CardTable v-else :fields="fields" :items="items.length > 0 ? [items[currentItemIndex]] : []" :showOptions="false"
      route="/admin-detail" :listOptions="optionsList" />
    <MobilePaginateComponent v-if="items.length > 0" :totalPages="totalPages" :modelValue="currentPage"
      :totalItems="totalItems" :currentItemIndex="currentItemIndex" :itemsPerPage="10"
      @update:modelValue="handlePageChange" @update:currentItemIndex="handleItemChange" />
  </div>

  <div class="hidden md:block">
    <TableComponent :filter-definitions="filterDefinitions" :filter-error="filterError" v-model:filters="filters" @filter-change="onFilterChange" :fields="fields" :items="items" :showViewMoreButton="false" route="/admin-detail" :showOptions="true"
      :listOptions="optionsList" />

    <PaginateComponent :totalPages="totalPages" :paginationInfo="paginationInfo" :modelValue="currentPage" @update:modelValue="handlePageChange" />

  </div>
</template>

<script setup>
import { computed, ref, onMounted } from 'vue';
import { useI18n } from 'vue-i18n';
import { useTableFilters } from '@/composables/useTableFilters';
import axios from 'axios';

import TableComponent from '@/components/table/TableComponent.vue';
import PaginateComponent from '@/components/paginate/PaginateComponent.vue';
import { usePaginationInfo } from '@/composables/usePaginationInfo';
import ButtonWhite from '@/components/button/ButtonWhite.vue';
import PrintTableComponent from '@/components/print/PrintTableComponent.vue';
import ExportFetch from '@/components/fetch/exportFetch.vue';
import CardTable from '@/components/table/CardTable.vue';
import MobilePaginateComponent from '@/components/paginate/MobilePaginateComponent.vue';
import PlusIcon from '@/assets/svg/PlusIcon.vue';
import TitlePrimary from '@/components/title/title-primary.vue';
import { isAdsManager } from '@/services/userRoles';


// --- Estado ---
const items = ref([]);
const searchText = ref('');
const currentPage = ref(1);
const totalPages = ref(1);
const { paginationInfo, setPaginationInfo } = usePaginationInfo();
const role = ref(localStorage.getItem("role"));
const isSearchActive = ref(false);
const selectedFilterName = ref({ key: '', label: '' });
const currentItemIndex = ref(0);
const totalItems = ref(0);
const canExportClients = isAdsManager();

const optionsList = ref([
  { key: '/Property', label: 'Comunidad', query: { type: 'comunidad' } },
  { key: '/luz', label: 'Luz' },
  { key: '/gas', label: 'Gas' },
  { key: '/request', label: 'Solicitudes' }
])

const formatDateDMY = (dateValue) => {
  if (!dateValue) return '-';

  const date = new Date(dateValue);
  if (Number.isNaN(date.getTime())) return '-';

  const day = date.getDate();
  const month = date.getMonth() + 1;
  const year = String(date.getFullYear());

  return `${day}/${month}/${year}`;
};

const mapAccountTypeFromRoles = (users = []) => {
  return users.map((user) => {
    const type = user.type_label
      ? user.type_label
      : user.roles && Array.isArray(user.roles)
      ? user.roles.map((role) => role.name).filter(Boolean).join(', ')
      : '';

    return {
      ...user,
      created_at: formatDateDMY(user.created_at),
      type: type || '-',
      commercial: user.commercial_label || user.commercial || '-'
    };
  });
};


// const printFile = async () => {

//   try {
//     const url = `${import.meta.env.VITE_API_URL}/supply/user/export?file_type=pdf&supply_type=light`;
//     const options = { method: 'GET', headers: { Accept: 'application/json' } };

//     const response = await fetch(url, options);
//     const data = await response.json();
//     console.log(data, 'data');

//   } catch (error) {
//     console.error(error);
//   }

// }


// --- funciones ---
const fetchDataFromApi = async () => {
  isSearchActive.value = false;
  try {
    const response = await axios.get(
      `${import.meta.env.VITE_API_URL}/admin/list` + `?per_page=10&page=${currentPage.value}&roles=horizontal,vertical,both`,
      {
        headers: {
          'Accept': 'application/json',
          'Authorization': `Bearer ${localStorage.getItem('token')}`
        },
      }
    );

    console.log('response fetchDataFromApi', response.data);
    if (response.data?.value.data) {
      items.value = mapAccountTypeFromRoles(response.data.value.data);
      totalPages.value = response.data.value.last_page;
      setPaginationInfo(response.data.value);
      totalItems.value = response.data.value.total ?? 0;
      currentPage.value = response.data.value.current_page;
    }
  } catch (error) {
    items.value = [];
    console.error('Error fetching data:', error);
  }
};

// Manejo de cambio de página
const handlePageChange = async (newPage) => {
  currentPage.value = newPage;
  if (isFiltering.value) {
    await runSearch(newPage);
  } else {
    await fetchDataFromApi();
  }

};
const handleItemChange = (newIndex) => {
  if (newIndex >= 0 && newIndex < items.value.length) {
    currentItemIndex.value = newIndex;
  }
};

async function performSearch(searchEndpoint, perPage, page = 1) {
  try {
    const response = await axios.get(
      `${import.meta.env.VITE_API_URL}${searchEndpoint}`,
      {
        params: {
          query: searchText.value,
          per_page: perPage,
          page: page, // Usar página recibida como parámetro
          search_by: selectedFilterName.value.key
        }
      }
    );
    console.log('search-results', response.data);
  } catch (error) {
    console.log('search-error', error);
  }
}
defineExpose({ performSearch });

// --- Funciones para los iconos ---
// const handleEdit = (item) => {
//   console.log('Editar:', item);
// };

// const handleAdd = (item) => {
//   console.log('Añadir/Otra acción:', item);
// };

const { t } = useI18n();

onMounted(async () => {
  fetchDataFromApi();
});


const fields = [
  { key: "id", label: "Codigo" },
  { key: "username", label: "Cuenta" },
  { key: "email", label: "Correo" },
  { key: "created_at", label: "Fecha" },
  { key: "cif", label: "CIF" },
  { key: "type", label: "Tipo de Cuenta" },
  { key: "commercial", label: "Asesor/comercial" },
  { key: "opciones", label: "Opciones" },
];

// --- filtros de cabecera ---
// Mismas opciones que etiquetas muestra la columna; `both` = horizontal y vertical a la vez
const ACCOUNT_TYPES = ['horizontal', 'vertical', 'both', 'comercio', 'delegacion'];

const filterDefinitions = computed(() => [
  { key: 'id', type: 'text' },
  { key: 'username', type: 'text' },
  { key: 'email', type: 'text' },
  { key: 'created_at', type: 'date' },
  { key: 'cif', type: 'text' },
  {
    key: 'type',
    type: 'select',
    options: ACCOUNT_TYPES.map((value) => ({ value, label: t(`common.requestTypes.${value}`) })),
  },
  { key: 'commercial', type: 'text' },
]);

const { filters, isFiltering, filterError, runSearch, onFilterChange } = useTableFilters({
  endpoint: '/user/superadmin/admins/search',
  perPage: 10,
  translate: t,
  onResults: (data) => {
    const page = data?.value;
    if (!page) return;
    // Mismo mapeo que la carga inicial: etiqueta del tipo y fecha en d/m/aaaa
    items.value = mapAccountTypeFromRoles(page.data || []);
    totalPages.value = page.last_page || 1;
    setPaginationInfo(page);
    totalItems.value = page.total ?? 0;
    currentPage.value = page.current_page || 1;
    isSearchActive.value = true;
  },
  onCleared: () => {
    isSearchActive.value = false;
    currentPage.value = 1;
    fetchDataFromApi();
  },
});
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s, transform 0.2s;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
  transform: translateY(-10px);
}
</style>
